import { X } from "lucide-react";

interface ReplyQuoteProps {
  name: string;
  preview: string;
  onCancel: () => void;
}

const ReplyQuote = ({ name, preview, onCancel }: ReplyQuoteProps) => (
  <div className="flex items-center gap-2 rounded-lg bg-muted px-3 py-2 mb-2 border-l-2 border-primary">
    <div className="min-w-0 flex-1">
      <p className="text-xs font-medium text-primary">Replying to {name}</p>
      <p className="truncate text-xs text-muted-foreground">{preview}</p>
    </div>
    <button onClick={onCancel} className="shrink-0 text-muted-foreground">
      <X size={14} />
    </button>
  </div>
);

export default ReplyQuote;
